import {translation} from "../../../settings/translate/fa";

export const notFound = () => {
    return (
        <div className='row py-5 position-relative cBg3 justify-content-center cPx1 cFlex2'>
            <div className='cContainer col-12'>
                <div className='row justify-content-center'>
                    <div className='col-12 cZindex2'>
                        <div className='p-5 cBg10 rounded rounded-3'>
                            <p className='text-center mb-0 cFontSize14_768 cFontSize16 cColor2 fw-bold lh-lg'>{translation.msgError404}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}